"use client"

import ErrorPage from "@/app/components/StatusPages/ErrorPage"

interface GlobalErrorProps {
  error: Error & { digest?: string }
}

/**
 * GlobalError component that handles application-wide errors with context-aware messaging
 */
export default function GlobalError({ error }: GlobalErrorProps): JSX.Element {
  return (
    <ErrorPage
      error={error}
      name="global-error"
      title="Server Error"
      description="We apologize, but something went wrong on our servers. This isn't your fault - it's on us."
    />
  )
}
